module.exports = __webpack_public_path__ + "img/32.d5addbd8.png";